<template>
  <div class="parking">
    <div class="title">商场服务</div>
    <div class="entry">
      <div class="left">
        <img class="car" :src="icon.car" alt="" />
      </div>
      <div class="middle">
        停车缴费
      </div>
      <div class="right">
        <div class="btn" @click="onBtnClick">
          <span>去缴费</span>
          <img class="arrow" :src="icon.arrow" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    floor: Object,
    home: Object
  },
  data() {
    return {
      icon: {
        car:
          'https://img.chinabeego.com/uploadfile/2022/4/18/16502678535293026188043424131.png',
        arrow:
          'https://img.chinabeego.com/uploadfile/2022/4/18/16502683912774078674738703948.png'
      }
    };
  },
  created() {
    
  },
  methods: {
    onBtnClick() {

    }
  }
};
</script>

<style lang="less" scoped>
.parking {
  background-color: #ffffff;
  border-radius: 20px;
  padding: 0 20px 20px 20px;
}
.title {
  font-size: 28px;
  font-weight: 500;
  color: #3B3A38;
  padding: 15px 0;
}
.entry {
  height: 80px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  background: linear-gradient(90deg, #fffaeb 0%, #ffebc2 100%);
  padding: 0 10px;
  .car {
    width: 68px;
    height: 68px;
    display: block;
  }
  .left {
    padding-left: 45px;
    padding-right: 50px;
  }
  .middle {
    flex: 1;
    font-size: 28px;
    font-weight: bold;
    color: #bea167;
  }
  .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    height: 60px;
    border-radius: 30px;
    font-size: 24px;
    color: #bea167;
    padding-left: 30px;
    padding-right: 20px;
  }
  .arrow {
    display: block;
    width: 24px;
    height: 24px;
    margin-left: 20px;
  }
}
</style>
